import { UpdateCardQuery } from "../../api/query.types";
import { UpdateCardFunc, useUpdateSingleCardMutation } from "./mutations/useUpdateSingleCardMutation";

export type EditSeaTagsFromCardsFunc = (
  params: { id: UpdateCardQuery["id"]; tagsList: string[] },
  options: Parameters<UpdateCardFunc>[1]
) => void;

export type EditSeaTagsFromCardsReturnType = {
  editSeaTagsFromCards: EditSeaTagsFromCardsFunc;
  isSeaTagsProcessing: boolean;
  isSeaTagsError: boolean;
  isSeaTagsSuccess: boolean;
};

export const useSeaSavedCardTagsMutation = (): EditSeaTagsFromCardsReturnType => {
  const { updateCard, isCardUpdateSuccess, isCardUpdateError, isCardUpdateLoading } = useUpdateSingleCardMutation();

  const editSeaTagsFromCards: EditSeaTagsFromCardsFunc = (params, options) => {
    updateCard({ id: params.id, data: { tags: params.tagsList } }, options);
  };

  return {
    editSeaTagsFromCards,
    isSeaTagsProcessing: isCardUpdateLoading,
    isSeaTagsError: isCardUpdateError,
    isSeaTagsSuccess: isCardUpdateSuccess,
  };
};
